import {DiReact} from "react-icons/di";
import {FaNodeJs} from "react-icons/fa";
import {SiExpress,SiMongodb} from "react-icons/si";
import { SiFiverr } from "react-icons/si";
import { AiFillGithub,AiFillLinkedin,AiFillYoutube } from "react-icons/ai";
import { CgFigma } from "react-icons/cg";
import { TbBrandReactNative } from "react-icons/tb";
import { SiAdobexd } from "react-icons/si";

export const menu = [
    {name:"About"},
    {name:"Services"},
    {name:"Skill"},
    {name:"Projects"},
    {name:"Testimonial"},
    {name:"Contact"},
]



export const projects = [
    {
      id:1,
      title: 'Hunters Association',
      image: 'https://i.postimg.cc/NFPfp7hp/image.png',
      category:"Network",
      data:{
        description:`Welcome to Hunters Association, your ultimate hub for all things anime and beyond! Here, you’ll find detailed information about our channels, groups, admins, bots, and more. Check out our featured anime channel, Anime x Hunters, where you can download your favorite anime with ease..!`,
        demoLink: "https://t.me/Hunters_Association",
      },
      stack:[
        {
          name:"Network",
          icon: <DiReact/>,
          iconColor:"skyblue",
        },
        {
          name:"Association",
          icon: <FaNodeJs/>,
          iconColor:"green",
        },
        {
          name:"WatchAnimes",
          icon: <SiExpress/>,
        },
        {
          name:"WatchFree",
          icon: <SiMongodb/>,
          iconColor:"limegreen",
        },
      ]
    },
    { 
      id:2,
      title: 'Anime x Hunters',
      image: 'https://i.postimg.cc/XNyxDDBT/gear-5-luffy-artwork-5k-3840x2160-18363.jpg',
      category:"Channels",
      data:{
         description: `
Anime X Hunters" is a vibrant Telegram channel dedicated to all things anime. Offering a voyage into the diverse world of Japanese animation, it serves as a hub for fans to explore, Whether you're a seasoned otaku or just dipping your toes into the anime ocean, this channel promises an exciting journey through the colorful and dynamic realm of Japanese animation. Join the crew and set sail on an anime adventure!`,
         demoLink: "https://t.me/Anime_X_Hunters",
      },
      stack:[
        {
          name:"WatchAnime",
          icon: <SiAdobexd/>,
          iconColor:"skyblue",
        },
        {
          name:"NewAnime",
          icon: <FaNodeJs/>,
          iconColor:"green",
        },
        {
          name:"WatchFree",
          icon: <SiExpress/>,
        },
        {
          name:"BestAnime",
          icon: <CgFigma/>,
          iconColor:"limegreen",
        },
      ]
    },
    {
      id:3,
      title: 'Ongoing Hunters',
      image: 'https://i.postimg.cc/Y0qVjRHm/image-2024-09-07-131203978.png',
      category:"Channels",
      data:{
        description: `Lets Dive into the world of ongoing anime with Ongoing Hunters! We bring you the freshest episodes, breaking updates, and deep dives into the most captivating series currently airing. Join us and stay on top of the anime scene, where the action never stops!`,
        demoLink: "https://t.me/Ongoing_Anime_X_Hunter",
      },
      stack:[
        {
          name:"OngoingAnime",
          icon: <CgFigma/>,
          iconColor:"skyblue",
        },
        {
          name:"AiringAnime",
          icon: <SiExpress/>,
          iconColor:"green",
        },
        {
          name:"Otaku",
          icon: <SiAdobexd/>,
        },
        {
          name:"WatchFree",
          icon: <FaNodeJs/>,
          iconColor:"limegreen",
        },
      ]
    },
    {
      id:4,
      title: 'Aʟʜᴀɪᴛʜᴀᴍ',
      image: 'https://i.postimg.cc/504rDqny/image-2024-09-07-144555272.png',
      category:"Bots",
      data:{
        description: `telegram Bot to store Posts and Documents and it can Access by Special Links. Custom Auto Delete Features with 2, 3 & 4 Force Subs Channel Support And Many More Features. Check Branch To Know More About Force Subs Channel & token verification too.`,
        demoLink: "https://github.com/Sahil0976/Multi-ForceSub_3buttons",
      },
      stack:[
        {
          name:"FileStore",
          icon: <TbBrandReactNative/>,
          iconColor:"skyblue",
        },
        {
          name:"3Fsub",
          icon: <FaNodeJs/>,
          iconColor:"green",
        },
        {
          name:"MultiFsub",
          icon: <SiExpress/>,
        },
        {
          name:"MongoDb",
          icon: <SiMongodb/>,
          iconColor:"limegreen",
        },
      ]
    },
    {
      id:5,
      title: 'Anime Index',
      image: 'https://i.postimg.cc/85yTYCB8/image-2024-09-07-150151218.png',
      category:"Channels",
      data:{
        description: `Discover the Ultimate Anime Index Looking for a comprehensive list of anime? Our channel provides an extensive index of all anime series, making it easy for you to find and explore your next binge-watch or revisit classics. Join us and dive into the world of anime, one series at a time!`,
        demoLink: "https://t.me/Anime_Index_Hunters",
      },
      stack:[
        {
          name:"AnimeIndex",
          icon: <CgFigma/>,
          iconColor:"skyblue",
        },
        {
          name:"AllAnime",
          icon: <FaNodeJs/>,
          iconColor:"green",
        },
        {
          name:"WatchFree",
          icon: <SiExpress/>,
        },
        {
          name:"WatchAnime",
          icon: <FaNodeJs/>,
          iconColor:"limegreen",
        },
      ]
    },
  ]
  


export const experience = [
    {
        title:"Graphic Designer",
        data:[
            {
                skill:"Adobe Photoshop",
                level:"Experienced",
            },
            {
                skill:"Corel Draw",
                level:"Intermediate",
            },
            {
                skill:"Adobe Illustrator",
                level:"Intermediate",
            },
        ]
    },
    {
        title:"Frontend Development",
        data:[
            {
                skill:"HTML",
                level:"Advance",
            },
            {
                skill:"CSS",
                level:"Advance",
            },
            {
                skill:"JavaScript",
                level:"Advance",
            },
            {
                skill:"Angular",
                level:"Intermediate",
            },
            {
                skill:"Bootstrap",
                level:"Experienced",
            },
            {
                skill:"React",
                level:"Experienced",
            },
            {
                skill:"Ember JS",
                level:"Advance",
            },
        ]
    },
    {
        title:"Backend Development",
        data:[
            {
                skill:"Node JS",
                level:"Experienced",
            },
            {
                skill:"MangoDB",
                level:"Intermediate",
            },
            {
                skill:"Java",
                level:"Intermediate",
            },
            {
                skill:"Python",
                level:"Advance",
            },
            {
                skill:"MySQL",
                level:"Experienced",
            },
        ]
    },
]

export const socialHandles = [
  {
    name:"Fiverr",
    icon:<SiFiverr/>,
    link:"",
  },
  {
    name:"Github",
    icon:<AiFillGithub/>,
    link:"https://github.com/Sahil0976",
  },
  {
    name:"LinkedIn",
    icon:<AiFillLinkedin/>,
    link:"",
  },
  {
    name:"Youtube",
    icon:<AiFillYoutube/>,
    link:"",
  },
];
